export const endpoint = {
	base: "",
	groupId: "/:groupId",
	enqueteId: `/:enqueteId`,
	gtResult: "/gt-result/:enqueteId",
	crossResult: "/cross-result/:enqueteId",
	setting: "/setting/:enqueteId",
	questions: "/questions/:enqueteId",
} as const;
